import React from 'react';
import SitePrivacyPolicyBody from '../body/SitePrivacyPolicy';
import Base from './Base';

const SitePrivacyPolicy = () => {
    return (
        <>
            <Base body={<SitePrivacyPolicyBody />} title="プライバシーポリシー" />
        </>
    );
}

export default SitePrivacyPolicy;